import React, { useState, useEffect } from 'react';
import api from '../utils/api';

function ClientsPage() {
    const [clients, setClients] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [selectedClient, setSelectedClient] = useState(null);
    const [formData, setFormData] = useState({
        client_name: '',
        company_name: '',
        email: '',
        phone: '',
        address: '',
        website: '',
        notes: '',
        status: 'active'
    });

    useEffect(() => {
        loadClients();
    }, []);

    const loadClients = async () => {
        try {
            const response = await api.getClients();
            if (response.data.success) {
                setClients(response.data.clients);
            }
        } catch (error) {
            console.error('Error loading clients:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            if (selectedClient) {
                await api.updateClient(selectedClient.id, formData);
            } else {
                await api.createClient(formData);
            }
            setShowModal(false);
            resetForm();
            loadClients();
        } catch (error) {
            alert('Error saving client');
        }
    };

    const resetForm = () => {
        setFormData({
            client_name: '',
            company_name: '',
            email: '',
            phone: '',
            address: '',
            website: '',
            notes: '',
            status: 'active'
        });
        setSelectedClient(null);
    };

    const editClient = (client) => {
        setSelectedClient(client);
        setFormData(client);
        setShowModal(true);
    };

    const deleteClient = async (id) => {
        if (window.confirm('Are you sure you want to delete this client?')) {
            try {
                await api.deleteClient(id);
                loadClients();
            } catch (error) {
                alert('Error deleting client');
            }
        }
    };

    if (loading) return <div className="loading">Loading...</div>;

    return (
        <div className="page">
            <div className="page-header">
                <h1>Clients</h1>
                <button onClick={() => setShowModal(true)} className="btn-primary">
                    + Add Client
                </button>
            </div>

            <div className="clients-grid">
                {clients.map(client => (
                    <div key={client.id} className="client-card">
                        <div className="client-header">
                            <h3>{client.client_name}</h3>
                            <span className={`status-badge ${client.status}`}>
                                {client.status}
                            </span>
                        </div>
                        {client.company_name && <p className="company">{client.company_name}</p>}
                        <div className="client-details">
                            {client.email && <p>✉️ {client.email}</p>}
                            {client.phone && <p>📞 {client.phone}</p>}
                            {client.website && <p>🌐 {client.website}</p>}
                        </div>
                        <div className="client-actions">
                            <button onClick={() => editClient(client)} className="btn-secondary">
                                Edit
                            </button>
                            <button onClick={() => deleteClient(client.id)} className="btn-danger">
                                Delete
                            </button>
                        </div>
                    </div>
                ))}
            </div>

            {showModal && (
                <div className="modal-overlay" onClick={() => { setShowModal(false); resetForm(); }}>
                    <div className="modal" onClick={(e) => e.stopPropagation()}>
                        <h2>{selectedClient ? 'Edit Client' : 'Add Client'}</h2>
                        <form onSubmit={handleSubmit}>
                            <div className="form-row">
                                <div className="form-group">
                                    <label>Client Name *</label>
                                    <input
                                        type="text"
                                        value={formData.client_name}
                                        onChange={(e) => setFormData({...formData, client_name: e.target.value})}
                                        required
                                    />
                                </div>
                                <div className="form-group">
                                    <label>Company Name</label>
                                    <input
                                        type="text"
                                        value={formData.company_name}
                                        onChange={(e) => setFormData({...formData, company_name: e.target.value})}
                                    />
                                </div>
                            </div>
                            <div className="form-row">
                                <div className="form-group">
                                    <label>Email</label>
                                    <input
                                        type="email"
                                        value={formData.email}
                                        onChange={(e) => setFormData({...formData, email: e.target.value})}
                                    />
                                </div>
                                <div className="form-group">
                                    <label>Phone</label>
                                    <input
                                        type="tel"
                                        value={formData.phone}
                                        onChange={(e) => setFormData({...formData, phone: e.target.value})}
                                    />
                                </div>
                            </div>
                            <div className="form-group">
                                <label>Website</label>
                                <input
                                    type="url"
                                    value={formData.website}
                                    onChange={(e) => setFormData({...formData, website: e.target.value})}
                                />
                            </div>
                            <div className="form-group">
                                <label>Address</label>
                                <textarea
                                    value={formData.address}
                                    onChange={(e) => setFormData({...formData, address: e.target.value})}
                                    rows="2"
                                />
                            </div>
                            <div className="form-group">
                                <label>Notes</label>
                                <textarea
                                    value={formData.notes}
                                    onChange={(e) => setFormData({...formData, notes: e.target.value})}
                                    rows="3"
                                />
                            </div>
                            <div className="form-group">
                                <label>Status</label>
                                <select
                                    value={formData.status}
                                    onChange={(e) => setFormData({...formData, status: e.target.value})}
                                >
                                    <option value="active">Active</option>
                                    <option value="inactive">Inactive</option>
                                    <option value="pending">Pending</option>
                                </select>
                            </div>
                            <div className="form-actions">
                                <button type="button" onClick={() => { setShowModal(false); resetForm(); }} className="btn-secondary">
                                    Cancel
                                </button>
                                <button type="submit" className="btn-primary">
                                    {selectedClient ? 'Update' : 'Create'}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
}

export default ClientsPage;
